import styled from 'styled-components'

export const PointList = styled.ul`
	text-align: left;
	display: flex;
	flex-direction: column;
	row-gap: 16px;
	padding: 0px;
	margin: 16px 0 32px;
`
